module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "The"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_The",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WOLF MOON")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("The Farmers’ Almanac derives the names of the months from the Native Americans of what is now the north-eastern United States.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Wolf Moon is the Moon of January, the moon when the wolves howl in hunger and want; the moon of deepest cold and darkness.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e69fd3b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fmtext1.vue
// module id = 69
// module chunks = 0